import axiosInstance from "../../api/axiosInstance";
import { endpoints } from "../../services/endpoints";
import { uploadBannerRequest, uploadBannerRequestError, uploadBannerRequestSuccess } from "../slices/UploadBannerSlice";

export const UploadBannerAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(uploadBannerRequest());
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.uploadBanner,
                data: data,
                headers: { "Content-Type": "application/json" },
            })
            return dispatch(uploadBannerRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(uploadBannerRequestError(_error));
        }
    };
};
